<span [class.error-details]="errors > 0" (click)="showErrors()">
  {{ errors }}
</span>

<ng-template #errorsTemplateRef>
  <div class="table-wrapper">
    <cdk-virtual-scroll-viewport tvsItemSize="48" class="wrapper">
      <table mat-table [dataSource]="dataSource">
        <ng-container *ngFor="let columnConfig of config.displayedColumns">
          <ng-container matColumnDef="{{ columnConfig.name }}">
            <th mat-header-cell *matHeaderCellDef>
              <span [translate]="config.domainEndpoint + '/details/' + columnConfig.name"></span>
            </th>
            <td
              mat-cell
              [class.alc-cursor-pointer]="columnConfig.action"
              *matCellDef="let element"
              (click)="columnConfig.action && columnConfig.action(element)">
              <span *ngIf="!element[columnConfig.name]; else valueTemplate">N/A</span>
              <ng-template #valueTemplate>
                <ng-container [ngSwitch]="columnConfig.type">
                  <ng-container *ngSwitchCase="'link'">
                    <a [href]="element[columnConfig.name]">{{ element[columnConfig.name] }}</a>
                  </ng-container>
                  <ng-container *ngSwitchCase="'date'">
                    <span
                      >{{ element[columnConfig.name] | dateTimezone: 'shortDate' }}
                      {{ element[columnConfig.name] | dateTimezone: 'mediumTime' }}</span
                    >
                  </ng-container>

                  <ng-container *ngSwitchDefault>
                    <span>{{ element[columnConfig.name] }}</span>
                  </ng-container>
                </ng-container>
              </ng-template>
            </td>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </cdk-virtual-scroll-viewport>
  </div>
</ng-template>
